module.exports = __webpack_public_path__ + "static/img/mazzo-di-carte-4.90c66fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mazzo-di-carte-4.svg
// module id = ASde
// module chunks = 1